<template>
  <STooltip
    :tooltip="
      tr('client.company_card.badges_times_chosen_tooltip_vue', {
        timesChosen: timesChosenDisplay,
      })
    "
  >
    <div class="s-company-badge s-company-badge--times-chosen">
      <SCompanyBadgeStyles />
      {{
        tr("client.company_card.badges_times_chosen_vue", {
          timesChosen: timesChosenDisplay,
        })
      }}
    </div>
  </STooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { STooltip } from "@solvari/common-fe";
import { useI18nCompanyCard } from "@solvari/translations";

import SCompanyBadgeStyles from "./SCompanyBadgeStyles.vue";

const { tr } = useI18nCompanyCard();

const timesChosenMaxDisplay = 300;

const props = defineProps<{
  timesChosen: number;
}>();

const timesChosenDisplay = computed(() => {
  return props.timesChosen > timesChosenMaxDisplay
    ? `${timesChosenMaxDisplay}+`
    : String(props.timesChosen);
});
</script>
